/**
 * Single source of truth for date/time formatting across the UI.
 * Picked over per-page toLocaleString calls because mixing 2-digit
 * and 4-digit years was producing confused output (e.g. a sentinel
 * year 2098 showed as "12/31/98" and looked like 1998).
 *
 * Format: "Apr 27, 2026, 11:04 AM" — month-name + 4-digit year + 12h
 * time. Month-name avoids the US/EU 4/27 vs 27/4 ambiguity.
 */

const DATE_OPTS = { month: 'short', day: 'numeric', year: 'numeric' };
const TIME_OPTS = { hour: 'numeric', minute: '2-digit', hour12: true };
const DATETIME_OPTS = { ...DATE_OPTS, ...TIME_OPTS };
const DATETIME_SECONDS_OPTS = { ...DATETIME_OPTS, second: '2-digit' };

export function fmtDateTime(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, DATETIME_OPTS);
}

export function fmtDateTimeSeconds(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, DATETIME_SECONDS_OPTS);
}

export function fmtDate(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, DATE_OPTS);
}

export function fmtTime(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString(undefined, TIME_OPTS);
}
